import Enumerable from "linq";
import { ICopyLinkedTextsBehaviorSpecifiable, ICopyLinkedValuesBehavior } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { IntegerTranslator, StringTranslator } from "../../values";
import { RelationTranslator } from "./RelationTranslator";

export class CopyLinkedTextsBehaviorTranslator {
  from(bean: IXElementContentsObjectBean): ICopyLinkedValuesBehavior {
    return this.relationalItems.from<ICopyLinkedValuesBehavior>(
      bean,
      is => ({
        isEnable: true,
        links: Enumerable.from(is).select(i => ({
          no: this.integer.from(i["@copies"]),
          value: this.string.from(i["@value"]),
        })).toArray(),
      }),
      {
        isEnable: false,
        links: [],  
      });
  }

  to(object: ICopyLinkedTextsBehaviorSpecifiable): IXElementContentsObjectRelationalBean {
    return this.relationalItems.to(
      Enumerable.from(object.copyLinkedTextsBehavior.isEnable ? object.copyLinkedTextsBehavior.links : [])
        .select(l => ({
          "@copies": this.integer.to(l.no),
          "@value": this.string.to(l.value),
        }))
        .toArray());
  }

  private readonly relationalItems = new RelationTranslator("copies-text");
  private readonly string = new StringTranslator();
  private readonly integer = new IntegerTranslator();
}
